import { InsightCatalogue } from '../InsightCatalogue';
import {
  FullInsightPayload,
  InsightMetric,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface RequestsStatusPayload extends FullInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_REQUESTS_STATUS;
    id: string;
    attributes: {
      data: Array<{
        request_status: string;
        request_count: number;
      }>;
      aggregate: {
        total_requests: InsightMetric;
      };
    };
  };
}

export const parseRequestsStatusPayload = (
  payload: BaseInsightPayload
): RequestsStatusPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_REQUESTS_STATUS,
    data.attributes,
    true,
    true,
    ['total_requests']
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{ request_status: string; request_count: number }>;
    aggregate: { total_requests: InsightMetric };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_REQUESTS_STATUS,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
        aggregate: {
          total_requests: typedAttributes.aggregate.total_requests,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
